// extracted by mini-css-extract-plugin
export default {"mCard":"TA-z","image":"UA-z","imageNoBackground":"VA-z","imageHasCategory":"WA-z","fullWidth":"XA-z"};